var _rect, _desc, _defs, _title, _rect2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRing2Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.2.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent",
    id: "svg_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "3dccfbcf-e0ab-468f-be4d-03898d9f5733"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080,
    transform: "matrix(1,0,0,1,540,540) ",
    strokeWidth: 0,
    id: "svg_2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f832728e-c2d7-471e-959c-2089781cc2e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "43b1858a-cc38-4335-9fb3-b3a871f48a54",
    className: "selected",
    fill: "#0473b8",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 35,
    transform: "matrix(12.4,0,0,12.4,540,540) ",
    strokeWidth: 0,
    id: "svg_3",
    fill: "#0473b8",
    fillOpacity: 1
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing2Blue);
export default __webpack_public_path__ + "static/media/Ring2Blue.c20224d2bfb7f3a99b88060bb5dd2289.svg";
export { ForwardRef as ReactComponent };